import eventListeners from './event-listeners';
import addWidgetHandler from '../handlers/add-widget-handler';

const addWidgetListener = (element) => {
  eventListeners.add(element, 'ws:addWidget', addWidgetHandler, true);
};

export default addWidgetListener;
